export default __webpack_public_path__ + "static/media/address.361a702a.png";